import React, { useState, useEffect } from 'react';
import FlashMessages, {FlashMessageData} from '../../components/flashMessages.js'
import {_printNumber, _printShortFullDate} from '../../helpers/helpers.js'

import {ReportPageResult} from '../../../../server/routes/reports.js'

interface ReportProps {
    server: string;
    pageData: unknown;
}

export default function Report({ server, pageData }: ReportProps) {

    let [data, setData] = useState(pageData as ReportPageResult);
    const [flashProps, setFlashProps] = useState<FlashMessageData>({}) 

    return (
        <div>
            <div>
                <div className="row mt-5">
                    <div className="col-md-5 m-auto">
                        <div className="card card-body">
                            <form>
                            <div className="form-group">
                                    <FlashMessages props={flashProps} />
                                </div>
                                <div className="form-group">
                                    Date: {_printShortFullDate(data.Date)}
                                </div>
                                <div className="form-group">
                                    Name: {data.Name}
                                </div>
                                <div className="form-group">
                                    Websites: {_printNumber(data.DomainCount)}
                                </div>
                                <div className="form-group">
                                    <a 
                                        href={`/reports/${data.ReportId}/download`}
                                        className="btn btn-primary btn-block"
                                    >
                                        Download
                                    </a>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
